import React from 'react';
import { BookletPreview } from './BookletPreview';
import { PageIntro } from './PageIntro';
import { PageGLP1Overview } from './PageGLP1Overview';
import { PageGLP1Overview2 } from './PageGLP1Overview2';
import { PageGLP1Overview3 } from './PageGLP1Overview3';
import { PageGutSide } from './PageGutSide';
import { PageBrainSide } from './PageBrainSide';
import { Page1 } from './Page1';
import { PageTOC } from './PageTOC';
import { PageCopyright } from './PageCopyright';
import { DividerMedication } from './DividerMedication';
import { DividerFundamentals } from './DividerFundamentals';
import { DividerSupplements } from './DividerSupplements';
import { PageDoseManagement } from './PageDoseManagement';
import { PageDoseManagement2 } from './PageDoseManagement2';
import { Page2 } from './Page2';
import { Page2b } from './Page2b';
import { PageContext } from './PageContext';
import { PageEssentialsDivider } from './PageEssentialsDivider';
import { Page3 } from './Page3';
import { Page4 } from './Page4';
import { Page5 } from './Page5';
import { Page5b } from './Page5b';
import { Page6 } from './Page6';
import { Page7 } from './Page7';
import { Page8 } from './Page8';
import { Page9 } from './Page9';
import { Page10 } from './Page10';
import { Page11 } from './Page11';
import { Page12 } from './Page12';
import { PageMealTiming } from './PageMealTiming';
import { PageSupplementQuality } from './PageSupplementQuality';
import { PageHydration } from './PageHydration';
import { PageSleep } from './PageSleep';
import { DividerSideEffects } from './DividerSideEffects';
import { PageAcuteSideEffects } from './PageAcuteSideEffects';
import { PageChronicSideEffects } from './PageChronicSideEffects';
import { PageAlcohol } from './PageAlcohol';
import { PagePlateaus } from './PagePlateaus';
import { DividerLookingAhead } from './DividerLookingAhead';
import { PageTransitioning } from './PageTransitioning';
import { PageOutro } from './PageOutro';
import { PageOutro2 } from './PageOutro2';
import { PageAboutAuthor2 } from './PageAboutAuthor2';
import { FoodPhoto1 } from './FoodPhoto1';
import { FoodPhoto2 } from './FoodPhoto2';
import { FoodPhoto3 } from './FoodPhoto3';
import { FoodPhoto4 } from './FoodPhoto4';
import { FoodPhoto5 } from './FoodPhoto5';
// Supplement Pages
import { SupplementWheyProtein } from './SupplementWheyProtein';
import { SupplementMultiVitamin } from './SupplementMultiVitamin';
import { SupplementVitaminD } from './SupplementVitaminD';
import { SupplementCoQ10 } from './SupplementCoQ10';
import { SupplementElectrolytes } from './SupplementElectrolytes';
import { SupplementCreatine } from './SupplementCreatine';
import { SupplementSleepSupport } from './SupplementSleepSupport';
import { SupplementMagnesium } from './SupplementMagnesium';
import { SupplementAshwagandha } from './SupplementAshwagandha';
import { SupplementGlutathione } from './SupplementGlutathione';
import { SupplementOmega3 } from './SupplementOmega3';
import { SupplementAshwagandhaMuscle } from './SupplementAshwagandhaMuscle';
import { Printer, Lock, ShoppingCart } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
export function Booklet() {
  const [searchParams] = useSearchParams();
  const isPreview = searchParams.get('preview') === '1';
  if (isPreview) {
    return <main className="min-h-screen bg-bodybg px-4 py-8 sm:px-6 sm:py-12" data-id="element-558" data-mp="3ktmba9cnt2u1">
        <BookletPreview data-id="element-559" data-mp="3kvqppl86pk8k" />

        <section className="mx-auto w-full max-w-3xl px-4 py-12 text-center sm:py-16" data-id="element-560" data-mp="2x3s0ryftbqcy">
          <Lock className="mx-auto mb-6 h-10 w-10 text-tealslate" data-id="element-561" data-mp="2x5wc31g1jrn9" />
          <p className="mb-4 text-[10px] font-bold uppercase tracking-[0.3em] text-tealslate" data-id="element-562" data-mp="2s6jjs16ehsda">
            End of Preview
          </p>
          <h1 className="mb-5 font-serif text-3xl leading-tight text-white md:text-4xl" data-id="element-563" data-mp="315n2h41no5r9">
            That&apos;s the first taste.
          </h1>
          <p className="mx-auto mb-10 max-w-xl text-base leading-relaxed text-[#D8D8D0]" data-id="element-564" data-mp="ld7l8tyhw1xh">
            The full GLP-1 Nutrition Guide includes 40+ pages of practical
            frameworks for protecting muscle, managing side effects, dialing in
            supplements, and building habits that outlast the prescription.
          </p>
          <Link to="/shop" className="inline-flex items-center justify-center gap-2 px-8 py-4 text-[11px] font-bold uppercase tracking-[0.2em] text-white transition-colors hover:bg-tealslate/80" style={{
          backgroundColor: '#3B4A4F'
        }} data-id="element-565" data-mp="1gqrypnagn6xu">
            <ShoppingCart className="h-4 w-4" data-id="element-566" data-mp="1uo6q2xk9xosg" />
            Get the Full Guide
          </Link>
        </section>
      </main>;
  }
  return <>
      <button onClick={() => window.print()} className="print-button fixed top-6 right-6 z-50 bg-tealslate hover:bg-tealslate/80 text-white px-5 py-3 flex items-center gap-2 font-bold text-sm uppercase tracking-wider shadow-lg transition-colors" data-id="element-567" data-mp="24dqboazdfwr0">
        <Printer className="w-5 h-5" data-id="element-568" data-mp="2eamm4m8tysy7" />
        Save as PDF
      </button>
      <div className="print-container min-h-screen bg-bodybg py-12 flex flex-col items-center gap-12 overflow-y-auto" data-id="element-569" data-mp="2ieatp4xgpojg">
        <Page1 data-id="element-570" data-mp="6ocr02pwfayr" />
        <PageCopyright data-id="element-571" data-mp="2p4158xzbx8h" />
        <PageIntro data-id="element-572" data-mp="2ougm0vpeia6" />
        <PageTOC data-id="element-573" data-mp="2ob1erxfu7zu" />
        {/* Part One: Understanding Your Medication */}
        <DividerMedication data-id="element-574" data-mp="3tulv2304c6h5" />
        <PageGLP1Overview data-id="element-575" data-mp="3tvx8kujd8slg" />
        <PageGLP1Overview2 data-id="element-576" data-mp="3tx8ccucta0ck" />
        <PageGLP1Overview3 data-id="element-577" data-mp="3owu2d6rnggbw" />
        <PageGutSide data-id="element-578" data-mp="3oxlz4kwzgk3r" />
        <PageBrainSide data-id="element-579" data-mp="3oy55r5h6nm2h" />
        <PageDoseManagement data-id="element-580" data-mp="qeotgig0w6uf" />
        <PageDoseManagement2 data-id="element-581" data-mp="qey8xc3fyvlv" />
        <FoodPhoto1 data-id="element-582" data-mp="qe5cb3y75mhg" />
        {/* Part Two: The Fundamentals */}
        <DividerFundamentals data-id="element-583" data-mp="lfbvp2nm5fd2" />
        <Page2 data-id="element-584" data-mp="lg3u0l8lhr71" />
        <Page2b data-id="element-585" data-mp="lhoo69qzz84d" />
        <PageContext data-id="element-586" data-mp="govj1krm9xrr" />
        {/* Part Three: The Essentials */}
        <PageEssentialsDivider data-id="element-587" data-mp="gnaohv5ayetw" />
        <Page3 data-id="element-588" data-mp="bpsctwzwhli7" />
        <Page4 data-id="element-589" data-mp="bq26pvo2gct6" />
        <FoodPhoto2 data-id="element-590" data-mp="bqk816pl5h7y" />
        <Page6 data-id="element-591" data-mp="bp95tbbsghiy" />
        <Page7 data-id="element-592" data-mp="bpio0cqldke3" />
        <Page8 data-id="element-593" data-mp="bny035ys8zp7" />
        <PageHydration data-id="element-594" data-mp="194whruf2csqk" />
        <FoodPhoto3 data-id="element-595" data-mp="1967w2o64xivx" />
        <PageMealTiming data-id="element-596" data-mp="196r339u8ymv6" />
        <Page5 data-id="element-597" data-mp="196zgd2ua7u6w" />
        <Page5b data-id="element-598" data-mp="14eg01y47mkye" />
        <Page9 data-id="element-599" data-mp="14dxxkjqyfai1" />
        <Page10 data-id="element-600" data-mp="14deq5wyxk4i9" />
        <PageSleep data-id="element-601" data-mp="14cv9skoxho6c" />
        <Page11 data-id="element-602" data-mp="14cd3swcgrvl8" />
        {/* Part Four: Supplements */}
        <DividerSupplements data-id="element-603" data-mp="2yncwhe9y8pfm" />
        <PageSupplementQuality data-id="element-604" data-mp="2yn3dwbr8hkjy" />
        <SupplementWheyProtein data-id="element-605" data-mp="32nvmd2sa7lf6" />
        <SupplementMultiVitamin data-id="element-606" data-mp="32mu0e39q9eio" />
        <SupplementVitaminD data-id="element-607" data-mp="32n3w87hgefwa" />
        <SupplementCoQ10 data-id="element-608" data-mp="2owibed8fvvvr" />
        <SupplementOmega3 data-id="element-609" data-mp="2oxa3he2tvbha" />
        <SupplementElectrolytes data-id="element-610" data-mp="2ovyyxc1k5zp4" />
        <SupplementCreatine data-id="element-611" data-mp="2tvle3r0y5q0k" />
        <SupplementAshwagandhaMuscle data-id="element-612" data-mp="2tus4mialsmeq" />
        <SupplementSleepSupport data-id="element-613" data-mp="2ttqssblrjvvy" />
        <SupplementMagnesium data-id="element-614" data-mp="2eyaufue5hdtr" />
        <SupplementAshwagandha data-id="element-615" data-mp="2ey1aoojp82wi" />
        <SupplementGlutathione data-id="element-616" data-mp="2ewzopp159w00" />
        <FoodPhoto4 data-id="element-617" data-mp="2jxe09h1yfo2s" />
        {/* Part Five: Side Effects & Challenges */}
        <DividerSideEffects data-id="element-618" data-mp="2jvayjzrfw6i8" />
        <PageAcuteSideEffects data-id="element-619" data-mp="25xw7kqljfqo5" />
        <PageChronicSideEffects data-id="element-620" data-mp="25yo2dz7b9kdd" />
        <PageAlcohol data-id="element-621" data-mp="25zpfe97w0gxq" />
        <PagePlateaus data-id="element-622" data-mp="2awpnepoartrh" />
        <FoodPhoto5 data-id="element-623" data-mp="2avxop5zelfwz" />
        {/* Part Six: Looking Ahead */}
        <DividerLookingAhead data-id="element-624" data-mp="2ayk5zxc3j9se" />
        <PageTransitioning data-id="element-625" data-mp="45q6tvm5gdoq" />
        <PageOutro2 data-id="element-626" data-mp="47kq75hrvxqp" />
        <PageAboutAuthor2 data-id="element-627" data-mp="471alvflhlfu" />
        <Page12 data-id="element-628" data-mp="95cku79sxxyl" />
      </div>
    </>;
}